import classNames from 'classnames/bind';

import styles from './PostDetail.module.scss';
import { useContext, useEffect, useRef, useState } from 'react';
import Comment from '../Comment';
import { getData, postData } from '~/helper/apiService';
import { ToastContext } from '../Context/ToastProvider';
import PostPreviews from '../PostPreviews';
import useMeta from '~/hooks/useMeta';

import useWindowWidth from '~/hooks/useWindowWidth';
import PostDetailMobile from '~/Layouts/components/PostDetailMobile';

const cx = classNames.bind(styles);

function PostDetail({id}) {
  const [post, setPost] = useState([]);
  const [comments, setComments] = useState([]);
  const listRef = useRef();
  const formRef = useRef();
  const { addToast } = useContext(ToastContext);
  const windowWidth = useWindowWidth();
  
  useMeta({
    title: post ? `${post?.title} - Ngô Gia Quyến` : "Ngô Gia Quyến - Blog Cá Nhân",
    description: post?.content?.substring(0, 160) + '...',
    keywords: `${post?.title}, bài viết, Ngô Gia Quyến, công nghệ, lập trình, chia sẻ`,
    author: "Ngô Gia Quyến",
    url: `https://ngogiaquyen.id.vn/post-detail/${id}`,
  }, post);


  const loadData = async () => {
    const data = await getData(`/post/read/${id}`);
    setPost(data[0]);
  };

  const loadComment = async () => {
    const data = await getData(`/post/readcomment/${id}`);
    setComments(data);
  };

  useEffect(() => {
    loadData();
    loadComment();
  }, []);

  const handleAddComment = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);
    formData.append('post_id', id);

    const res = await postData(`/post/createcomment`, formData);
    if (res.status === 'success') {

      await loadComment();
      await loadData();
      formRef.current.reset();
      listRef.current.scrollTop = listRef.current.scrollHeight + 100;
    } else {
      addToast(res);
    }
  };

  const handleLike = async () => {
    const formData = new FormData();
    formData.append('id', post.id);

    const res = await postData('/post/like', formData);
    if (res.status === 'success') {
      loadData();
    } else {
      addToast(res);
    }
  };

  if(windowWidth <= 2) return <PostDetailMobile post={post} comments={comments}  handleLike={handleLike} onAddComment={handleAddComment}  listRef={listRef} formRef={formRef}/>

  return (
    <div className={cx('wrapper')}>
      <div className={cx('post-detail')}>
        <PostPreviews post={post} handleLike={handleLike} />
      </div>
      <div className={cx('comment-detail')}>
        <Comment comments={comments} onAddComment={handleAddComment} listRef={listRef} formRef={formRef} />
      </div>
    </div>
  );
}

export default PostDetail;
